let mdcTabs = [];
let resTags = [];
let posts = [];
let tr = [];
let constLinks = [];

function bindData() {
  if (window.resource_vue) {
    mdcTabs = window.resource_vue.mdcTabs;
    resTags = window.resource_vue.resTags;
    posts = window.resource_vue.posts;
    tr = window.resource_vue.tr;
    constLinks = window.resource_vue.constLinks;
  }
}
bindData();
export {
  mdcTabs,
  resTags,
  posts,
  tr,
  constLinks,
};


// WEBPACK FOOTER //
// ./App/components/ResourceList/handler.js